import { FC, useState } from "react";
import AccordionItem from "./components/AccordionItem";
import { TAccordion } from "../../types/contests";
import { useAppDispatch } from "../../hooks/redux-hooks";
import { setAccordionIsOpen } from "../../store/slices/contests";

export type TProps = {
  accordions?: TAccordion[];
};

const Accordion: FC<TProps> = ({ accordions }) => {
  const dispatch = useAppDispatch();

  const toggleClick = (index: number) => {
    dispatch(setAccordionIsOpen(index));
  };

  return (
    <div className="w-full max-w-[1000px] pb-3">
      {accordions?.map((accordion: TAccordion, index: number) => {
        return (
          <AccordionItem
            key={index}
            isOpen={accordion.isOpen}
            title={accordion.title}
            content={accordion.description}
            onClick={() => toggleClick(index)}
          />
        );
      })}
    </div>
  );
};

export default Accordion;
